import { useTranslation } from 'next-export-i18n';
import React from 'react';

import ActivelyFundraising from '@/components/atoms/ActivelyFundraising';
import More from '@/components/list/More';
import MoreSocial from '@/components/list/MoreSocial';
import type CompanyProps from '@/types/Company.type';

type RightPanelProps = {
  company: CompanyProps;
};

const RightPanel = ({
  company: {
    service_offereds,
    actively_foundraising_portfolio,
    partnership_opportunities,
    actively_hirings,
    website,
    contact_email,
    career_page,
    slug,
  },
}: RightPanelProps) => {
  const { t } = useTranslation();
  const serviceOffereds = service_offereds?.map((item) => item.name);
  const partnershipOpp = partnership_opportunities?.map((item) => item.name);
  const activelyHirings = actively_hirings?.map((item) => item.name);
  const urlSocial = `${process.env.NEXT_PUBLIC_WEB_URL}/${slug}`;

  return (
    <div className="grid grid-cols-1 gap-6">
      <MoreSocial title={t('company.shareToYourFriends')} url={urlSocial} />
      <More
        title={t('company.servicesOffers')}
        items={serviceOffereds || []}
        link={website!}
        linkLabel={t('company.visitWebsite')}
      />
      {actively_foundraising_portfolio && <ActivelyFundraising />}
      <More
        title={t('company.partnershipOpportunities')}
        items={partnershipOpp || []}
        link={`mailto:${contact_email}?Subject=Hello`}
        linkLabel={t('company.contact')}
      />
      <More
        title={t('company.activelyHiring')}
        items={activelyHirings || []}
        link={career_page!}
        linkLabel={t('company.visitCareerPage')}
      />
    </div>
  );
};

export default RightPanel;
